export const enMessages = {
  "common.none": "none",
  "common.missing": "missing",
  "common.ready": "ready",
  "common.unknown": "unknown",
  "common.untitled": "(untitled)",
  "common.yes": "yes",
  "common.no": "no",
  "command.exit.description": "Exit the current session",
  "command.help.description": "Show available commands",
  "command.status.description": "Show the current project status",
  "command.export.description": "Export the current conversation to Markdown",
  "command.help.header": "Available commands:",
  "command.help.footer": "Other input is sent directly to Kitty.",
  "tui.idle": "Idle",
  "tui.running": "Running",
  "tui.thinkingElapsed": "Thinking {elapsed}",
  "tui.background": "Background",
  "tui.failed": "Failed",
  "tui.waiting": "Waiting",
  "tui.backgroundRunning": "Background running",
  "tui.model": "Model",
  "tui.context": "Context",
  "tui.commands": "commands",
  "tui.commandPalette": "palette",
  "tui.inputPlaceholder": "Type a message",
  "tui.commandQuery": "Command",
  "tui.commandQueryPlaceholder": "Type a name or description",
  "tui.commandNoMatches": "No matching commands",
  "tui.history": "History",
  "tui.historyPlaceholder": "Type a keyword",
  "tui.historyNoMatches": "No matching input",
  "tui.scrollHelp": "↑↓ scroll  ·  Esc close",
  "tui.newContent": "New content · End to return to bottom",
  "tui.newContentRows": "{count} new line(s) · End to return to bottom",
  "tui.copySuccess": "Selected text copied.",
  "tui.copyUnavailable": "Copy failed: no clipboard channel is available in this terminal.",
  "tui.copyFailed": "Copy failed: {error}",
  "tui.draftBusy": "Draft cannot be submitted yet: SQLite is busy. Try again.",
  "tui.externalEditorFailed": "External editor failed: {error}",
  "tui.authorTip": "Explore and enjoy!",
  "tui.tool.created": "Created",
  "tui.tool.updated": "Updated",
  "tui.tool.read": "Read",
  "tui.tool.ran": "Ran",
  "tui.tool.updatedPlan": "Updated Plan",
  "tui.newSession": "New session",
  "tui.sessionControls": "↑↓ select  ·  Enter open  ·  Esc exit",
  "tui.unnamedSession": "Untitled session {id}",
  "tui.time.now": "just now",
  "tui.time.minutes": "{count} min ago",
  "tui.time.hours": "{count} hr ago",
  "tui.time.days": "{count} days ago",
  "tui.time.weeks": "{count} weeks ago",
  "tui.time.months": "{count} months ago",
  "tui.time.years": "{count} years ago",
  "tui.help.discovery": "Discovery",
  "tui.help.input": "Input",
  "tui.help.navigation": "Navigation",
  "tui.help.commandCompletion": "Command completion",
  "tui.help.commandPalette": "Command palette",
  "tui.help.historySearch": "Search input history",
  "tui.help.shortcuts": "Keyboard help",
  "tui.help.submit": "Submit",
  "tui.help.newline": "New line",
  "tui.help.lineBounds": "Line start/end",
  "tui.help.killYank": "Cut line end/start/previous word; paste",
  "tui.help.externalEditor": "External editor",
  "tui.help.historyNavigation": "Move in multiline input or history",
  "tui.help.wordMovement": "Move by word",
  "tui.help.menuConfirm": "Complete/confirm menu",
  "tui.help.closeOverlay": "Close top overlay",
  "tui.help.interrupt": "Interrupt current turn",
  "tui.help.redraw": "Redraw terminal",
  "interaction.steerAccepted": "Current conversation guided.",
  "interaction.interrupted": "Interrupted the current turn. You can continue typing.",
  "interaction.interrupting": "Interrupt already in progress.",
  "interaction.exitHint": "This session will not exit automatically. Type quit or q to exit.",
  "interaction.sessionSaved": "Session saved.",
  "interaction.turnInterrupted": "Turn interrupted. You can keep chatting.",
  "interaction.requestFailed": "The request failed.",
  "interaction.sessionAlive": "The request failed, but the session is still alive. You can keep chatting.",
  "interaction.inputRejected": "Input was not accepted: {error}",
  "interaction.recoveredTurns": "Recovered {count} interrupted turn state(s). Resumable work will continue from durable session and tool facts.",
  "interaction.inspectProcessesFailed": "Failed to inspect running background processes: {error}",
  "interaction.runningProcesses": "Running processes detected. Exiting now will kill them all.",
  "interaction.killProcessesPrompt": "Kill all running processes and exit? [y/N] ",
  "interaction.exitCancelled": "Exit cancelled. Background processes will keep running.",
  "interaction.stopProcessesPartial": "Could not stop all background processes. Still running: {pids}. Exit cancelled.",
  "interaction.stoppedProcesses": "Stopped {count} background process(es).",
  "interaction.stopProcessesFailed": "Failed to stop background processes: {error}",
  "interaction.forcedStopPartial": "Could not stop all running processes. Still running: {pids}.",
  "interaction.forcedStopped": "Stopped {count} running process(es).",
  "interaction.forcedStopFailed": "Failed to stop running processes: {error}",
  "local.noMessages": "Current session has no messages yet.",
  "local.conversationExported": "Conversation exported: {path}",
  "scene.headline.blockedOne": "One background task needs attention.",
  "scene.headline.blockedMany": "{count} background tasks need attention.",
  "scene.headline.watchOne": "One background task is running without output yet.",
  "scene.headline.watchMany": "{count} background tasks are running without output yet.",
  "scene.headline.activeOne": "One background task is running.",
  "scene.headline.activeMany": "{count} background tasks are running.",
  "scene.headline.noSession": "No session has started yet.",
  "scene.headline.ready": "Latest session is ready.",
  "scene.noFocus": "No current focus yet.",
  "scene.next.wait": "Wait for the active task, or inspect it with `kitty status` / `kitty background`.",
  "scene.next.start": "Start a session with `kitty`.",
  "scene.next.continue": "Continue from the latest session.",
  "scene.noBlockers": "No blockers visible.",
  "scene.contextUnmeasured": "Context has not been measured yet",
  "scene.providerUsageUnavailable": "provider usage unavailable",
  "scene.noModelRequest": "No model request recorded yet",
  "scene.noToolProjection": "Tool output has not needed projection yet",
  "scene.recoveryOne": "One background task needs recovery attention.",
  "scene.recoveryMany": "{count} background tasks need recovery attention.",
  "scene.wakeOne": "One wake signal is recorded.",
  "scene.wakeMany": "{count} wake signals are recorded.",
  "scene.recoveryClear": "Recovery is clear.",
  "scene.noSkills": "No runtime skills are discovered in this project.",
  "scene.skillIssues": "Inspect skill issues before relying on those skills.",
  "scene.skillsReady": "Skills are ready; load full skill content only when needed.",
  "scene.noBackground": "No background work is running.",
  "scene.backgroundRunning": "Background work is running; wait or inspect latest output.",
  "scene.executionState": "Execution is {status}.",
  "scene.executionTask": "{kind} task",
  "scene.taskActive": "Task is active.",
  "scene.cost.context": "{percent}% context{compressed}",
  "scene.cost.compressed": ", compressed",
  "scene.cost.stable": "stable {ratio}",
  "scene.cost.totalTokens": "{count} tokens",
  "scene.cost.cacheUnknown": "cache unknown",
  "scene.cost.cached": "{count} cached",
  "scene.cost.cacheHit": "{percent}% hit",
  "scene.tool.recent": "{count} recent",
  "scene.tool.saved": "{count} tokens saved est.",
  "scene.tool.recoverable": "{count} recoverable",
  "scene.tool.degraded": "{count} degraded",
  "scene.execution.backgroundBlocked": "Inspect output with `kitty background read {id}` or stop with `kitty background stop {id}`.",
  "scene.execution.backgroundWatch": "Wait for first output or inspect with `kitty background read {id}`.",
  "scene.execution.backgroundActive": "Inspect with `kitty background read {id}` or `kitty background wait {id}` if you need the result now.",
  "scene.execution.inspectBeforeContinue": "Inspect {kind} {id} before continuing.",
  "scene.execution.watch": "Watch {kind} {id} for output or deadline.",
  "scene.kind.background": "background",
  "status.project": "Project",
  "status.state": "State",
  "status.currentScene": "Current scene",
  "status.configuration": "Configuration",
  "status.thinking": "Thinking",
  "status.reasoningEffort": "Reasoning effort",
  "status.extensions": "Enabled extensions",
  "status.recentEvents": "Recent events",
  "status.now": "Now",
  "status.focus": "Focus",
  "status.next": "Next",
  "status.blocked": "Blocked",
  "status.background": "Background",
  "status.skills": "Skills",
  "status.cost": "Cost",
  "status.toolOutput": "Tool output",
  "status.recovery": "Recovery",
  "status.runtimeFacts": "Runtime facts",
  "status.session": "Session",
  "status.sessions": "Sessions",
  "status.contextBudget": "Context budget",
  "status.workset": "Workset",
  "status.modelCache": "Model cache",
  "status.projectOrientation": "Project orientation",
  "status.executions": "Executions",
  "status.wakeSignals": "Wake signals",
  "status.taskFacts": "Task facts",
  "status.latestSession": "Latest session",
  "status.projectFacts": "Project facts",
  "status.hotspots": "Context budget hotspots",
  "status.sources": "Context budget sources",
  "status.cacheLayout": "Cache layout",
  "status.modelRequests": "Recent model requests",
  "status.toolOutputs": "Recent tool output",
  "status.recentExecutions": "Recent executions",
  "status.skillsAttention": "Skills needing attention",
  "status.files": "{count} file(s)",
  "status.readyCount": "{ready}/{total} ready",
  "status.activeTotal": "{active} active / {total} total",
  "status.messageCount": "{count} message(s)",
  "status.compressed": "compressed={mode}",
  "status.notCompressed": "compressed=no",
  "status.usageUnavailable": "usage unavailable",
  "status.usageProviderUnavailable": "usage unavailable from provider",
  "common.ok": "ok",
  "common.present": "present",
  "common.unresolved": "unresolved",
  "common.custom": "custom",
  "common.changed": "changed",
  "common.clean": "clean",
  "common.unavailable": "unavailable",
  "common.notReady": "not ready",
  "common.failed": "failed",
  "common.tracked": "tracked",
  "common.interrupted": "interrupted",
  "cli.program.description": "Kitty - an agent for durable execution.",
  "cli.version.description": "Print the current Kitty version.",
  "cli.option.model": "Override the configured model",
  "cli.option.cwd": "Working directory for this run",
  "cli.option.json": "Print structured JSON.",
  "cli.option.timeoutMs": "Wait timeout in milliseconds.",
  "cli.option.readMode": "Read mode: summary, tail, or full.",
  "cli.option.tail": "Number of output lines to read in tail mode.",
  "cli.argument.promptOptional": "Optional one-shot prompt. Without a prompt, opens interactive mode.",
  "cli.argument.promptRequired": "Prompt to send",
  "cli.argument.sessionIdOptional": "Session id. Defaults to the latest session.",
  "cli.argument.backgroundAction": "Optional action: list, read, wait, stop",
  "cli.argument.backgroundId": "Background execution id for read, wait, or stop",
  "cli.argument.changeIdOptional": "Optional change id",
  "cli.command.background": "Inspect, read, wait for, or stop background executions.",
  "cli.command.start": "Initialize the project and open the local Kitty console.",
  "cli.command.undo": "Undo the latest recorded change or a specific change id.",
  "cli.command.status": "Show the current project runtime status.",
  "cli.command.run": "Run a one-shot prompt in a new session.",
  "cli.command.resume": "Resume the latest session or a specific session in interactive mode.",
  "cli.command.telegram": "Serve Telegram private-chat control.",
  "cli.command.telegramServe": "Run the Telegram private-chat service via long polling.",
  "cli.command.weixin": "Control Kitty through Weixin iLink private chats.",
  "cli.command.weixinLogin": "Sign in to Weixin iLink with a QR code.",
  "cli.command.weixinServe": "Run the Weixin iLink private-chat service.",
  "cli.command.weixinLogout": "Clear the Weixin iLink login state.",
  "cli.run.incomplete": "Run did not complete.",
  "cli.background.idRequired": "background {action} requires an execution id.",
  "cli.background.unknownAction": "Unknown background action: {action}. Use list, read, wait, or stop.",
  "cli.background.none": "No background executions recorded.",
  "cli.sessions.none": "No saved sessions found.",
  "cli.start.ready": "Kitty local console is ready.",
  "cli.start.browserFailed": "The browser could not be opened automatically. Open the URL above manually.",
  "cli.undo.done": "Undid {id}",
  "cli.tui.requiresTty": "kitty requires an interactive TTY. Use kitty run <prompt> for one-shot execution.",
  "cli.tui.unavailable": "TUI entrypoint is unavailable. Run npm.cmd run build and try again. Cause: {error}",
  "cli.sessionPicker.prompt": "Select a session (number, or 0 for new): ",
  "cli.sessionPicker.recent": "Recent sessions",
  "cli.sessionPicker.new": "New session",
  "cli.sessionPicker.invalid": "Invalid selection. Try again.",
  "cli.sessionPicker.invalidRange": "Enter a listed number, or 0 for a new session.",
  "cli.intro.session": "session",
  "cli.intro.cwd": "cwd",
  "cli.intro.tools": "Tools",
  "cli.intro.commands": "Commands",
  "preflight.project": "project",
  "preflight.state": "state",
  "preflight.file": "file",
  "preflight.envKeys": "env keys",
  "preflight.activeExpected": "{active} active / {expected} expected",
  "preflight.missingKeys": "missing keys",
  "preflight.provider": "provider",
  "preflight.model": "model",
  "preflight.baseUrl": "baseUrl",
  "preflight.providerPreset": "provider preset",
  "preflight.providerProfile": "provider profile",
  "preflight.modelProfile": "model profile",
  "preflight.wireApi": "wire API",
  "preflight.catalog": "catalog",
  "preflight.apiKey": "api key",
  "preflight.status": "preflight",
  "preflight.next": "next",
  "preflight.runInit": "run `kitty start` to create the local .kitty files and open the console",
  "preflight.fillMissing": "open `.kitty/.env` and fill the missing keys",
  "preflight.setApiKey": "set `KITTY_API_KEY` in `.kitty/.env`",
  "preflight.startKitty": "start Kitty with `kitty`",
  "preflight.reviewEnv": "review `.kitty/.env`",
  "status.totalSkipped": "{total} total, {skipped} skipped",
  "status.blockedCount": "{count} blocked",
  "status.label.reason": "reason",
  "status.label.messages": "messages",
  "status.label.directories": "dirs",
  "status.label.scripts": "scripts",
  "status.label.tests": "tests",
  "status.label.git": "git",
  "status.label.read": "read",
  "status.label.changed": "changed",
  "status.label.lastTool": "last",
  "status.label.change": "change",
  "status.label.chars": "chars",
  "status.label.lines": "lines",
  "status.label.stable": "stable",
  "status.label.stableChars": "stable chars",
  "status.label.tail": "tail",
  "status.label.tailChars": "tail chars",
  "status.label.stableRatio": "stable ratio",
  "status.label.stableSources": "stable sources",
  "status.label.volatileSources": "volatile sources",
  "status.label.provider": "provider",
  "status.label.duration": "duration",
  "status.label.usage": "usage",
  "status.label.kind": "kind",
  "status.label.mode": "mode",
  "status.label.raw": "raw",
  "status.label.projected": "projected",
  "status.label.saved": "saved",
  "status.label.savedRatio": "saved ratio",
  "status.label.recoverable": "recoverable",
  "status.label.degraded": "degraded",
  "status.label.fullOutput": "full output",
  "status.label.risk": "risk",
  "status.label.summary": "summary",
  "status.label.next": "next",
  "status.label.lastOutput": "last output",
  "status.label.actor": "actor",
  "status.label.expected": "expected",
  "status.label.resources": "resources",
  "status.label.dependencies": "dependencies",
  "status.label.host": "host",
  "status.label.message": "message",
  "status.label.error": "error",
  "status.label.state": "state",
  "status.label.issues": "issues",
  "status.label.cached": "cached",
  "status.label.cacheMiss": "cache miss",
  "status.label.cacheHit": "cache hit",
  "status.label.input": "input",
  "status.label.output": "output",
  "status.label.reasoning": "reasoning",
  "status.label.cacheRead": "cache read",
  "status.label.cacheWrite": "cache write",
  "runtime.channel.agent": "Kitty",
  "runtime.channel.system": "System",
  "runtime.reasoning": "reasoning",
  "runtime.tool": "tool",
  "runtime.result": "result",
  "runtime.preview": "preview",
  "runtime.content": "content",
  "runtime.toolFailed": "Tool failed: {name}",
  "runtime.thinking": "thinking",
  "telegram.help.help": "/help            Show Telegram usage help",
  "telegram.help.stop": "/stop            Stop the current Telegram task without shutting down the bot service",
  "telegram.help.status": "/status          Show current runtime status",
  "telegram.help.files": "File usage:",
  "telegram.help.sendFile": "- Send files directly to the private chat. Kitty downloads them and attaches them to the current session.",
  "telegram.help.analyzeFile": "- Ask Kitty to analyze the file you just sent or send a named file back.",
  "telegram.help.stopTask": "- Use /stop when you need to stop the current task.",
  "telegram.help.note": "Terminal-only commands are not available in Telegram.",
  "telegram.blockedLocal": "This command is not available in Telegram. Use /help to see available commands.",
  "telegram.prefix.warning": "Warning",
  "telegram.prefix.error": "Error",
  "telegram.prefix.interrupt": "Interrupt",
  "telegram.stopConfirmed": "Stopping the current Telegram task. The bot stays online for your next request.",
  "telegram.noTask": "No Telegram task is running right now.",
  "remote.command.stop.description": "Stop the current task and keep the service online",
  "remote.command.new.description": "Start a new session and keep the previous history",
  "remote.stopConfirmed": "Stopping the current task. The service stays online for your next request.",
  "remote.noTask": "No task is running right now.",
  "remote.newConfirmed": "A new session is ready. Your previous session is still saved.",
  "remote.noSession": "No session has been created for this chat yet.",
  "remote.blockedCommand": "This command is not available here. Use /help to see the current commands.",
  "telegram.tokenMissing": "Telegram token missing. Set KITTY_TELEGRAM_TOKEN or config.telegram.token.",
  "telegram.whitelistEmpty": "Telegram whitelist is empty. Set KITTY_TELEGRAM_ALLOWED_USER_IDS or config.telegram.allowedUserIds.",
  "weixin.notLoggedIn": "Weixin is not signed in. Run kitty weixin login first.",
  "weixin.whitelistEmpty": "Weixin whitelist is empty. Set KITTY_WEIXIN_ALLOWED_USER_IDS.",
  "weixin.qrCode": "[weixin] Open or scan in Weixin: {value}",
  "weixin.scanned": "[weixin] QR code scanned. Waiting for confirmation.",
  "weixin.loginSucceeded": "[weixin] Signed in as user={userId}",
  "weixin.loggedOut": "[weixin] Signed out.",
  "remote.service.online": "Private-chat remote service is online",
  "remote.service.state": "State",
  "remote.service.allowed": "Allowed users",
  "remote.service.transport": "Transport",
  "cli.setup.projectNotReady": "Project is not ready to run.",
  "cli.setup.createTemplate": "Create or repair the project template with: kitty start",
  "cli.setup.configFile": "Config file: {path}",
  "cli.setup.fillAndStart": "Then fill the required values and start Kitty.",
  "cli.setup.originalError": "Original error: {error}",
  "cli.setup.apiKeyMissing": "Provider API key is missing.",
  "cli.setup.setApiKey": "Set KITTY_API_KEY in: {path}",
  "cli.setup.thenRestart": "Then start Kitty again.",
  "common.active": "active",
  "common.undone": "undone",
  "status.label.pid": "pid",
  "status.label.health": "health",
  "status.label.deadline": "deadline",
  "status.label.files": "files",
  "interaction.queuedRestart": "Accepted input remains durable and will resume after restart.",
  "interaction.detachedRecovery": "Current work remains durable and will resume when this session opens again.",
  "web.pageTitle": "Kitty Agent",
  "web.common.back": "Back to workspace",
  "web.common.save": "Save configuration",
  "web.common.sendTest": "Test connection",
  "web.common.testingConnection": "Checking the connection, credentials, and model list. Please wait…",
  "web.common.start": "Start",
  "web.common.stop": "Stop",
  "web.common.github": "Open Kitty on GitHub",
  "web.common.officialSite": "Official site",
  "web.common.apiKeyPortal": "Get API Key",
  "web.common.notConfigured": "Not configured",
  "web.common.custom": "Custom configuration",
  "web.common.requestFailed": "Request failed ({status})",
  "web.common.connectionSuccess": "Connected",
  "web.common.serviceState": "Service status: {status}",
  "web.common.models": "{count} models",
  "web.common.skills": "{count} available Skills",
  "web.common.eventUpdated": "Event updated",
  "web.common.eventDisconnected": "The local event connection was interrupted. The browser will reconnect automatically; service state is unaffected.",
  "web.status.stopped": "Stopped",
  "web.status.starting": "Starting",
  "web.status.running": "Running",
  "web.status.stopping": "Stopping",
  "web.status.failed": "Failed to start",
  "web.status.unknown": "Unknown status",
  "web.login.waiting": "Waiting for scan",
  "web.login.scanned": "Scanned",
  "web.login.connected": "Signed in",
  "web.login.failed": "Sign-in failed",
  "web.workflow.basic": "Basic settings",
  "web.workflow.config": "Language model settings",
  "web.workflow.media": "Image and video settings",
  "web.workflow.plugins": "Plugin & Skill switches",
  "web.workflow.other": "Other settings",
  "web.workflow.weixin": "Weixin remote control",
  "web.workflow.telegram": "Telegram remote control",
  "web.workflow.skills": "Skills",
  "web.workflow.web": "Kitty web control",
  "web.workflow.loadingConfig": "Loading current configuration...",
  "web.workflow.loadingService": "Loading service status...",
  "web.workflow.loadingSkills": "Loading capabilities...",
  "web.workflow.basicNote": "Language and profile",
  "web.workflow.configNote": "Provider and model",
  "web.workflow.mediaNote": "Image and video generation",
  "web.workflow.mediaSummary": "Independent multimodal provider and model configuration",
  "web.workflow.pluginsNote": "Capability switches",
  "web.workflow.otherNote": "Advanced parameters",
  "web.workflow.otherSummary": "Context, files, and remote protocol parameters",
  "web.workflow.weixinNote": "Weixin remote control",
  "web.workflow.telegramNote": "Telegram remote control",
  "web.workflow.skillsNote": "Read only",
  "web.workflow.webNote": "User-friendly control interface",
  "web.workflow.webSummary": "Web chat and runtime control",
  "web.workflow.guide": "Choose a module to continue setting up or managing Kitty.",
  "web.config.description": "Choose the language-model provider, credentials, and reasoning behavior.",
  "web.config.currentTitle": "Current configuration",
  "web.config.providerTitle": "Provider",
  "web.config.providerHint": "A preset fills the recommended values. Every field remains directly editable.",
  "web.config.validationTitle": "Test the connection",
  "web.config.validationHint": "Uses the last saved configuration to read model metadata. It does not generate content or consume model tokens.",
  "web.config.settingsTitle": "Model behavior",
  "web.config.settingsHint": "Thinking, reasoning effort, output limits, and reasoning visibility take effect after saving.",
  "web.config.extensionsTitle": "Extensions",
  "web.config.runtimeTitle": "Runtime parameters",
  "web.config.preset": "Provider preset",
  "web.config.provider": "Provider",
  "web.config.model": "Model",
  "web.config.baseUrl": "Base URL",
  "web.config.apiKey": "API Key",
  "web.config.apiKeyHint": "This is the current provider key. After switching providers, enter the API key for the selected provider.",
  "web.config.currentLoaded": "Current value loaded",
  "web.config.saved": "Kitty configuration saved.",
  "web.config.probeSuccess": "Connected · {probe} · {models} · {baseUrl}",
  "web.media.description": "Configure image and video generation independently from the active language model.",
  "web.media.currentTitle": "Current media configuration",
  "web.media.providerTitle": "Image and video provider",
  "web.media.providerHint": "Image and video share the media credential but remain independent from the language model.",
  "web.media.preset": "Media preset",
  "web.media.provider": "Provider",
  "web.media.imageModel": "Image model",
  "web.media.videoModel": "Video model",
  "web.media.baseUrl": "Base URL",
  "web.media.apiKey": "Media API Key",
  "web.media.apiKeyHint": "The current media key is shown here. Saving an empty field preserves it.",
  "web.media.timeout": "Request timeout (ms)",
  "web.media.pollInterval": "Video polling interval (ms)",
  "web.media.saved": "Image and video settings saved.",
  "web.media.validationTitle": "Test media connection",
  "web.media.validationHint": "Reads the model endpoint without generating an image or video.",
  "web.media.studioTitle": "Generate media",
  "web.media.studioHint": "Run a direct image or video request through the configured media provider.",
  "web.media.imageTab": "Image",
  "web.media.videoTab": "Video",
  "web.media.prompt": "Prompt",
  "web.media.size": "Image size",
  "web.media.ratio": "Image ratio",
  "web.media.videoSize": "Video frame",
  "web.media.duration": "Duration",
  "web.media.negativePrompt": "Negative prompt",
  "web.media.generateImage": "Generate image",
  "web.media.generateVideo": "Create video",
  "web.media.stopPolling": "Stop polling",
  "web.media.download": "Download",
  "web.media.videoId": "Video ID",
  "web.media.nextPoll": "Next poll",
  "web.media.generating": "Generating image…",
  "web.media.imageCompleted": "Image ready",
  "web.media.videoCreating": "Creating video task…",
  "web.media.videoQueued": "Video queued",
  "web.media.videoWaiting": "Waiting for the next poll",
  "web.media.videoInProgress": "Video is processing",
  "web.media.videoCompleted": "Video ready",
  "web.basic.description": "Choose the interface language and Agent profile from the current profile registry.",
  "web.basic.saved": "Basic settings saved.",
  "web.plugins.description": "Enable or disable Kitty plugins and browse the Skills available to this project.",
  "web.plugins.saved": "Plugin settings saved.",
  "web.other.description": "Adjust context, file limits, and low-frequency Weixin and Telegram protocol parameters.",
  "web.other.saved": "Other settings saved.",
  "web.weixin.description": "Choose who may use Kitty, sign in by QR code, then start the local service.",
  "web.weixin.allowedTitle": "User allowlist",
  "web.weixin.userId": "User IDs",
  "web.weixin.usersPlaceholder": "Separate multiple IDs with commas",
  "web.weixin.saved": "Allowed users saved.",
  "web.weixin.loginTitle": "Sign in to Weixin",
  "web.weixin.loginHint": "The QR code and credentials belong only to this local project.",
  "web.weixin.generateQr": "Generate QR code",
  "web.weixin.logout": "Sign out",
  "web.weixin.startTitle": "Run service",
  "web.weixin.startHint": "After starting, messages and Agent activity appear below.",
  "web.weixin.streamEmpty": "Weixin service events will appear here",
  "web.weixin.waitingLogin": "Waiting for Weixin QR sign-in",
  "web.weixin.credentialsCleared": "Weixin credentials cleared",
  "web.weixin.qrGenerating": "Generating QR code...",
  "web.weixin.connected": "Weixin credentials connected",
  "web.weixin.qrAlt": "Weixin sign-in QR code",
  "web.telegram.description": "Save the Bot Token and allowed users, verify the bot identity, then start the service.",
  "web.telegram.botTitle": "Bot configuration",
  "web.telegram.token": "Bot Token",
  "web.telegram.tokenHint": "This is the current value in `.kitty/.env`. Saving an empty field preserves the existing token.",
  "web.telegram.users": "Allowed user IDs",
  "web.telegram.usersPlaceholder": "Separate multiple IDs with commas",
  "web.telegram.saved": "Telegram configuration saved.",
  "web.telegram.verifyTitle": "Verify Bot Token",
  "web.telegram.verifyHint": "Calls Telegram `getMe` and displays the bot username when successful.",
  "web.telegram.startTitle": "Run service",
  "web.telegram.startHint": "After starting, send a Telegram message to see the complete activity below.",
  "web.telegram.streamEmpty": "Telegram service events will appear here",
  "web.telegram.probeSuccess": "Connected · @{identity}",
  "web.skills.description": "Read the capabilities currently discoverable by this project. The browser never modifies Skill files.",
  "web.skills.empty": "No Skills are available in this project",
  "web.skills.source": "Skill source",
  "web.stream.inbound": "Message received",
  "web.stream.status": "Service",
  "web.stream.reasoning": "Reasoning",
  "web.stream.assistant": "Replying",
  "web.stream.final": "Final reply",
  "web.stream.toolCall": "Tool call",
  "web.stream.toolProgress": "Tool running",
  "web.stream.toolResult": "Tool result",
  "web.stream.toolError": "Tool error",
  "web.stream.error": "Error",
  "web.shell.connected": "Connected",
  "web.shell.disconnected": "Connection closed",
  "web.shell.thinking": "Thinking",
  "web.shell.stopped": "Stopped",
  "web.shell.inputPlaceholder": "Send a message",
  "web.shell.send": "Send",
  "web.shell.stop": "Stop",
  "web.shell.empty": "Give Kitty a task.",
  "web.shell.reasoning": "Thinking",
  "web.shell.user": "You",
  "web.shell.assistant": "Kitty",
  "web.shell.toolUpdating": "Updating {target}",
  "web.shell.toolWriting": "Writing a file",
  "web.shell.toolReading": "Reading {target}",
  "web.shell.toolReadingGeneric": "Reading a file",
  "web.shell.toolRunning": "Running {command}",
  "web.shell.toolRunningGeneric": "Running a command",
  "web.shell.toolCalling": "Calling {name}",
  "web.shell.toolUpdated": "Updated {target}",
  "web.shell.toolCreated": "Created {target}",
  "web.shell.toolRead": "Read {target}",
  "web.shell.toolDone": "Tool completed",
  "web.shell.toolFailed": "Tool failed",
  "web.shell.toolPlan": "Plan updated · {completed}/{total} complete",
  "web.shell.commandDone": "Command completed",
  "web.shell.commandFailed": "Command failed",
  "web.runtime.locale": "Interface language",
  "web.runtime.profile": "Agent profile",
  "web.runtime.thinking": "Thinking mode",
  "web.runtime.reasoningEffort": "Reasoning effort",
  "web.runtime.maxOutputTokens": "Maximum output tokens",
  "web.runtime.contextWindowMessages": "Context window messages",
  "web.runtime.maxContextChars": "Maximum context characters",
  "web.runtime.contextSummaryChars": "Context summary characters",
  "web.runtime.maxReadBytes": "Maximum file read bytes",
  "web.runtime.projectDocMaxBytes": "Maximum project document bytes",
  "web.runtime.commandStallTimeoutMs": "Command stall timeout (ms)",
  "web.runtime.showReasoning": "Show reasoning",
  "web.runtime.telegramApiBaseUrl": "Telegram API base URL",
  "web.runtime.telegramProxyUrl": "Telegram proxy URL",
  "web.runtime.telegramPollingTimeoutSeconds": "Telegram polling timeout (seconds)",
  "web.runtime.telegramPollingLimit": "Telegram polling batch limit",
  "web.runtime.telegramPollingRetryBackoffMs": "Telegram polling retry delay (ms)",
  "web.runtime.telegramMessageChunkChars": "Telegram message chunk size (characters)",
  "web.runtime.telegramTypingIntervalMs": "Telegram typing interval (ms)",
  "web.runtime.telegramDeliveryMaxRetries": "Telegram delivery retry limit",
  "web.runtime.telegramDeliveryBaseDelayMs": "Telegram delivery base delay (ms)",
  "web.runtime.telegramDeliveryMaxDelayMs": "Telegram delivery maximum delay (ms)",
  "web.runtime.weixinBaseUrl": "Weixin iLink base URL",
  "web.runtime.weixinCdnBaseUrl": "Weixin CDN base URL",
  "web.runtime.weixinPollingTimeoutMs": "Weixin polling timeout (ms)",
  "web.runtime.weixinPollingRetryBackoffMs": "Weixin polling retry delay (ms)",
  "web.runtime.weixinMessageChunkBytes": "Weixin message chunk size (bytes)",
  "web.runtime.weixinTypingIntervalMs": "Weixin typing interval (ms)",
  "web.runtime.weixinQrTimeoutMs": "Weixin QR timeout (ms)",
  "web.runtime.weixinRouteTag": "Weixin route tag",
  "web.locale.zh-CN": "Simplified Chinese",
  "web.locale.en": "English",
  "web.locale.ja": "Japanese",
  "web.locale.ko": "Korean",
  "web.option.enabled": "Enabled",
  "web.option.disabled": "Disabled",
  "web.option.xhigh": "Extra high",
  "web.option.high": "High",
  "web.option.medium": "Medium",
  "web.option.low": "Low",
  "web.option.minimal": "Minimal",
  "web.option.true": "Yes",
  "web.option.false": "No",
  "web.extension.todo": "Session checklists and visible progress.",
  "web.extension.scheduler": "Durable reminders and scheduled local commands without model polling.",
  "web.extension.worktree": "Git worktree discovery and lifecycle management.",
  "web.extension.network": "HTTP requests, probes, downloads, traces, and OpenAPI inspection.",
  "web.extension.media": "Generate images and create, poll, and download videos by video_id.",
  "web.extension.background": "Background commands with durable lifecycle and output tracking.",
  "web.extension.documents": "Bounded DOCX and text PDF reading plus Word document writing.",
  "web.extension.skills": "Project Skill discovery and explicit loading.",
  "web.event.toolFailed": "{name} failed",
  "web.event.toolProgress": "{name} is receiving arguments",
  "web.event.writeDocument": "Write document",
  "web.event.changeFile": "Change file",
  "web.event.readDocument": "Read document",
  "web.event.readFile": "Read file",
  "web.event.fromOffset": "from {offset}",
  "web.event.runCommand": "Run command",
  "web.event.directory": "Directory: {path}",
  "web.event.runTool": "Run tool · {name}",
  "web.event.fileCreated": "File created",
  "web.event.fileUpdated": "File updated",
  "web.event.documentCreated": "Document created",
  "web.event.documentUpdated": "Document updated",
  "web.event.readComplete": "Read complete",
  "web.event.commandFailed": "Command failed",
  "web.event.commandComplete": "Command complete",
  "web.event.planUpdated": "Plan updated · {completed}/{total}",
  "web.event.toolComplete": "{name} complete",
  "web.event.missingTarget": "No target provided",
} as const;

export type MessageKey = keyof typeof enMessages;
export type MessageCatalog = Record<MessageKey, string>;
